import { configureStore } from "@reduxjs/toolkit";
import cBookingReducer from "./slice/currentBookingSlice";
import gdInfoSlice from "./slice/gdInfoSlice";
import userInfoSlice from './slice/userInfoSlice';

export const store = configureStore({
    reducer: {
        cBookingReducer,
        gdInfoSlice,
        userInfoSlice
    }
})